import {CityXReferenceService} from './cityXReferenceService.js';
import {PostalCodeService} from './postalCodeService.js';
import {RoutingToolsService} from './routingToolsService.js';
import {GeospatialOptionsService} from './geospatialOptionsService.js';

export var RoutingService = {
	cityXReferenceService: null,
	postalCodeService: null,
	routingToolsService: null,
	geospatialOptionsService: null,
		
	getCityXReferenceService: function(){
		if (!this.cityXReferenceService) {
			this.cityXReferenceService = new CityXReferenceService();
		}
		return this.cityXReferenceService;
	},
	
	getPostalCodeService: function(){
		if (!this.postalCodeService) {
			this.postalCodeService = new PostalCodeService();
		}
		return this.postalCodeService;
	},
	
	getRoutingToolsService: function(){
		if (!this.routingToolsService) {
			this.routingToolsService = new RoutingToolsService();
		}
		return this.routingToolsService;
	},
	
	getGeospatialOptionsService: function(){
		if (!this.geospatialOptionsService) {
			this.geospatialOptionsService = new GeospatialOptionsService();
		}
		return this.geospatialOptionsService;
	}
	
};


